import gql from 'graphql-tag';

export const all = gql`{
    vessels {
        id
        name
        oldName
        year
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/vessel.js